import { retryAfterSeconds } from "utils/http/retryAfterSeconds";

/**
 * The `/check-ip` refusals the site explains to the user (spec
 * 2026-10-20-website-api-settings, Stage 3):
 *  - 429 `{status: "error", reason: "rate_limited", retry_after}` + `Retry-After`:
 *    a signed-in user with 0 requests ran more than 30 free checks a minute;
 *  - 503 `{detail: "providers_unavailable"}`: every data provider is down.
 * Anything else (network error, timeout, other statuses) is `unknown`.
 */
export type CheckIpError =
  | { reason: "rate_limited"; retryAfter?: number }
  | { reason: "providers_unavailable" }
  | { reason: "unknown" };

export const RATE_LIMITED = "rate_limited";
export const PROVIDERS_UNAVAILABLE = "providers_unavailable";

export const parseCheckIpError = (err: any): CheckIpError => {
  const response = err?.response;
  const body = response?.data;
  if (response?.status === 429 || body?.reason === RATE_LIMITED) {
    const headers = response?.headers || {};
    return {
      reason: "rate_limited",
      retryAfter:
        retryAfterSeconds(body?.retry_after) ??
        retryAfterSeconds(headers["retry-after"]),
    };
  }
  if (body?.detail === PROVIDERS_UNAVAILABLE || body?.reason === PROVIDERS_UNAVAILABLE) {
    return { reason: "providers_unavailable" };
  }
  return { reason: "unknown" };
};
